import { ethers } from 'ethers';
import { Network } from '../Networks/useNetworks';
import { ContractFactories, Contracts } from '../../contracts/types';

export interface IState {
	isEthereum: boolean;
	isLoggedIn: boolean;
	isLoading: boolean;
	isMetaMask: boolean;
	isChainValid: boolean;
	checkedLogin: boolean;
	account: string;
	chainId: Network;
	signer?: ethers.Signer;
	provider?: ethers.providers.Provider;
	contracts: {
		[p in Contracts]?: ethers.Contract;
	};
	contractFactories: {
		[p in ContractFactories]?: ethers.ContractFactory;
	};
}

export const emptyState: IState = {
	isEthereum: false,
	isLoggedIn: false,
	isLoading: true,
	isMetaMask: false,
	isChainValid: false,
	checkedLogin: false,
	account: ethers.constants.AddressZero,
	chainId: Network._,
	signer: undefined,
	provider: undefined,
	contracts: {
		hashupStore: undefined,
		igo: undefined,
		userProfile: undefined,
		hash: undefined,
	},
	contractFactories: {
		cartridge: undefined,
	},
};

export const Reducer = (state: IState, updatedProperties: Partial<IState>) => ({
	...state,
	...updatedProperties,
});
